import { render, staticRenderFns } from "./CampaignInfoPanel.vue?vue&type=template&id=1180587b&scoped=true&"
import script from "./CampaignInfoPanel.vue?vue&type=script&lang=js&"
export * from "./CampaignInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./CampaignInfoPanel.vue?vue&type=style&index=0&id=1180587b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1180587b",
  null
  
)

export default component.exports